/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import { Modal } from 'antd-mobile'
import VocPage from '@views/VocPage'
//css
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'

const VocPagePopup: React.FC = () => {
  const { globalStore, vocStore } = useRootStore()
  const { visiblePCVocPopup } = globalStore

  const onClickVocPageClose = async () => {
    await vocStore.attendVoc()
    globalStore.setVisiblePCVocPopup(false)
  }

  return (
    <Modal
      popup
      maskClosable={false}
      visible={visiblePCVocPopup}
      animated={isMobile}
      animationType="slide-up"
      title={
        <Fragment>
          <h1 className="title">고객의 소리</h1>
          <Button onClick={onClickVocPageClose} className="close-btn" css={CloseBtn}>
            <span className="close-txt">닫기</span>
          </Button>
        </Fragment>
      }
      className="full-modal message"
      onClose={onClickVocPageClose}
    >
      <div style={{ overflow: 'auto', height: '100%', background: 'none' }}>
        <VocPage/>
      </div>
      <ModalBg/>
    </Modal>
  )
}

export default observer(VocPagePopup)
